import config from '../../../config';
import trainTime from '../../../lib/TrainTime';
import { isUpdatedRefundCopyEnabled } from '../../../helpers/RefundCopy';

const getRefundCopyCutoverDate = () => trainTime(config.get('refundCopyCutoverDate'), 'YYYY-MM-DD');

export function shouldUseUpdatedRefundCopy(order) {
    const enableUpdatedRefundCopy = isUpdatedRefundCopyEnabled();
    const orderPurchaseDate = order && order.originalOrderPurchaseDate;

    if (!orderPurchaseDate) {
        return enableUpdatedRefundCopy;
    }

    return Boolean(enableUpdatedRefundCopy
        && orderPurchaseDate
        && orderPurchaseDate.isSameOrAfter(getRefundCopyCutoverDate()));
}
